export default __webpack_public_path__ + "static/media/icbc.c6ef0d7b.svg";